import React, { useContext, useEffect, useState } from "react"

import CommonContext from "@src/context"

import Section from "@components/section"
import ClickableImage from "@components/clickableImage"
import BottomButtons from "@components/bottomButtons"
import Button from "@components/button"
import En from "./sfv_en"
import Zh from "./sfv_zh"

import bgImage from "@images/sfv-bg.jpg"
import matchImg from "@images/season4/sfv-match.png"

const Sfv = () => {
  const [en, setEn] = useState(false)
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <Button
          color={"blue"}
          onClick={() => {
            setEn(en => !en)
          }}
        >
          {en ? "查看中文版" : "English"}
        </Button>
      </div>
      {en ? <En /> : <Zh />}
      <Section title="对阵表">
        <ClickableImage className="fluidImage" src={matchImg} />
      </Section>

      <div className="buttonsContainer" style={{ marginBottom: "10px" }}>
        <Button large color="blue" href="http://sparkidea.mikecrm.com/Uu9akFY">
          {en ? "Register" : "报名参赛"}
        </Button>
      </div>
      <p
        style={{
          display: "block",
          width: "400px",
          maxWidth: "100%",
          margin: "10px auto 0px",
        }}
      >
        本次比赛选手将由主办方随机分配到A、B、C、D四个小组进行比赛，分组信息将会在招募结束后在选手群内公式，请随时留意群内信息。
      </p>
    </div>
  )
}

export default Sfv
